export const GENERATE_RANDOM_NAME_ADJECTIVES = [
  "Swift",
  "Bright",
  "Quick",
  "Smart",
  "Clever",
  "Sharp",
  "Keen",
  "Wise",
  "Fast",
  "Bold",
];
export const GENERATE_RANDOM_NAME_NOUNS = [
  "Agent",
  "Bot",
  "Assistant",
  "Helper",
  "Worker",
  "Studio",
  "Mind",
  "Core",
  "Node",
  "Unit",
];
